import { memo, useEffect, useState } from "react";
import styled from "styled-components";
import Avatar from "~/layouts/components/Header/components/Avatar";
import { PiCheck } from "react-icons/pi";
import { IoEllipsisHorizontal } from "react-icons/io5";
import { Comment_Base } from "~/common/typescript/models/Comment";
import { Button, Input, Popover, Tag, Tooltip } from "antd";
import { CommentAPIs } from "~/common/typescript/apis/CommentAPIs";
import { useAtom } from 'jotai';
import CommentItemContextMenu from "./CommentItemContextMenu";
import CommentItemUpdateForm from "./CommentItemUpdateForm";
import { commentsAtom } from "~/components/Map/Comment/CommentStore";
import { formatRelativeTime } from "~/utils/dateUtils";


export enum CommentItemMode {
  View = 'view',
  Edit = 'edit',
}
interface CommentItemProps {
  comment: Comment_Base;
  mode?: CommentItemMode;
}
const CommentItem: React.FC<CommentItemProps> = (props: CommentItemProps) => {
  const { comment } = props;
  const [comments, setComments] = useAtom(commentsAtom);

  const [mode, setMode] = useState<CommentItemMode>(props.mode || CommentItemMode.View);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  // Sync mode with props when it changes, but only for newly created comments
  useEffect(() => {
    if (props.mode !== undefined && props.mode === CommentItemMode.Edit) {
      setMode(props.mode);
    }
  }, [props.mode, mode, comment.id]);
  const onClickCheck = async () => {
    const newValue = !comment.resolved;
    await CommentAPIs.remote_updateComment(comment.id!, {
      resolved: newValue,
    });

    setComments(comments.map((_comment) => {
      if (_comment.id === comment.id) {
        return {
          ...comment,
          resolved: newValue,
        };
      }
      return _comment;
    }));
  };

  const switchToEditMode = () => {
    setMode(CommentItemMode.Edit);
  };

  return <UI_Wrapper>
    <div style={{ width: 40, height: '100%' }}>
      <Avatar />
    </div>
    <div style={{ flex: 1 }}>
      <UI_Fullname>{comment.user?.fullname || 'Không tên'} {comment.resolved && <Tag color='green'>Xong</Tag>}</UI_Fullname>
      <UI_CreatedAt>{formatRelativeTime(comment.createdAt)}</UI_CreatedAt>
      {
        mode === CommentItemMode.View ? (
          <>
            <UI_Title style={{ textDecoration: comment.is_deleted ? 'line-through' : 'none' }}>{comment.title}</UI_Title>
            <UI_Content style={{ textDecoration: comment.is_deleted ? 'line-through' : 'none' }}>{comment.description}</UI_Content>
          </>
        ) : (
          <CommentItemUpdateForm comment={comment} callbackSaved={() => {
            setMode(CommentItemMode.View);
          }} />
        )
      }
    </div>
    <UI_Right className="right">
      {mode === CommentItemMode.View && (
        <Tooltip title='Đánh dấu là hoàn thành'>
          <UI_HeaderRight_item onClick={onClickCheck}>
            <PiCheck color={comment.resolved ? 'green' : 'black'} />
          </UI_HeaderRight_item>
        </Tooltip>
      )}
      <Popover
        open={isPopoverOpen}
        onOpenChange={setIsPopoverOpen}
        trigger="click"
        placement="bottomRight"
        title={null}
        arrow={false}
        content={<CommentItemContextMenu comment={comment} onClickEdit={switchToEditMode}
          onCloseContextMenu={() => setIsPopoverOpen(false)}
        />}>
        <UI_HeaderRight_item onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
          <IoEllipsisHorizontal />
        </UI_HeaderRight_item>
      </Popover>

    </UI_Right>
  </UI_Wrapper>
}

export default CommentItem;

const UI_Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 8px;
  position: relative;

  &:hover .right {
    display: flex;
  }
`;

const UI_Fullname = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
`;

const UI_CreatedAt = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
`;
const UI_Title = styled.div`
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
`;

const UI_Content = styled.div`
  font-size: 12px;
  color: #333;
  margin-bottom: 4px;
`;

const UI_Right = styled.div`
  display: none;
  position: absolute;
  right: 8px;
  top: 8px;
  flex-direction: row;
  gap: 4px;
`;
const UI_HeaderRight_item = styled.div`
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;

  &:hover {
    background-color: #f0f0f0;
  }
`;
